import { forwardRef, useEffect, useState, useRef } from "react";
import axios from "axios"
import { Avatar, Tabs, Card, Button, Modal, Space, Checkbox, Input, Divider, Form, Table } from "antd";
import { DownOutlined, DownloadOutlined, UpOutlined } from "@ant-design/icons";
import styled from "styled-components"
import s3Controller from "controllers/s3Controller";
import SentenceImageRightPrompt from "./SentenceImageRightPrompt";
import SentenceImageRightImageTab from "./SentenceImageRightImageTab";
import SentenceImageRight_ from "./SentenceImageRight_";


const { Meta } = Card;
const backend = process.env.REACT_APP_BACKEND;
const start = process.env.REACT_APP_VARIABLE_START
const end = process.env.REACT_APP_VARIABLE_END
const meaningPrompt = process.env.REACT_APP_MEANING_PROMPT
const backgroundPrompt = process.env.REACT_APP_BACKGROUND_PROMPT

const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

const SentenceImageRight = ({ data, imageDeleteHandler,orderChangeHandler, imageConfig, reRenderHandler, loadingHandler  }) => {

  const [promptRequest, setPromptRequest] = useState([meaningPrompt, backgroundPrompt])

  const promptRequestHandler = (prompt) => {
    setPromptRequest(prompt)
  }

  const items = [
    { label: "이미지", key: "item-1", style: { height: "100%", overflow:"auto" }, children: <SentenceImageRightImageTab data={data} imageDeleteHandler={imageDeleteHandler} orderChangeHandler={orderChangeHandler} imageConfig={imageConfig}/> }, // remember to pass the key prop
    { label: "프롬프트", key: "item-2", style: { height: "100%", overflow:"auto" }, children: <SentenceImageRightPrompt data={data} imageConfig={imageConfig} reRenderHandler={reRenderHandler} loadingHandler={loadingHandler} promptRequest={promptRequest} promptRequestHandler={promptRequestHandler}/> },
    { label: "임시테스트", key: "item-3", style: { height: "100%", overflow:"auto" }, children: <SentenceImageRight_ imageConfig={imageConfig}/> },

  ];

  return (
    <div style={{ width: "100%", flex:1, overflow:"auto"}}>
      <Tabs defaultActiveKey="item-1" destroyInactiveTabPane={true} type="card" size="middle" items={items} style={{ height: "100%", width: "100%"}} />
    </div>
  );
}

export default SentenceImageRight